const fullUrl = (relative) => {
  // History routes (/app/tasks/:id) must share the same static pipeline root.
  const base = import.meta.env.BASE_URL;
  return new URL(`${base}${relative.replace(/^\//, '')}`, document.location.origin).href;
};

const itkConfig = {
  pipelineWorkerUrl: fullUrl('/itk/itk-wasm-pipeline.min.worker.js'),
  imageIOUrl: fullUrl('/itk/image-io'),
  meshIOUrl: fullUrl('/itk/mesh-io'),
  pipelinesUrl: fullUrl('/itk/pipelines'),
};

export default itkConfig;
